import { FragmentDashboardEnvSchema } from '../scripts/envType';

export const FragmentEnv = FragmentDashboardEnvSchema.parse(
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  window.env ?? JSON.parse(import.meta.env.VITE_APP_ENV)
);
